// src/services/commonService.js
import { supabase } from "../supabaseClient";


// ... (keep your existing getAllDocuments function here) ...

/**
 * Fetch documents from a table where a specific column matches a value.
 * @param {string} tableName - 'topics', 'titles', etc.
 * @param {string} columnName - 'category_slug', 'id', etc.
 * @param {any} value - The value to filter by (e.g. 'grade_10')
 */
export const getDocumentsByColumn = async (tableName, columnName, value) => {
  if (!tableName || !columnName) throw new Error("Table and Column names are required");

  const { data, error } = await supabase
    .from(tableName)
    .select('*')
    .eq(columnName, value)
    .order('created_at', { ascending: false });

  if (error) {
    throw new Error(`Error fetching ${tableName}: ${error.message}`);
  }

  return data;
};

/**
 * Fetch ALL documents from a specific table.
 * @param {string} tableName - The exact name of the table in Supabase (e.g., 'titles', 'meets')
 */
export const getAllDocuments = async (tableName) => {
  if (!tableName) throw new Error("Table name is required");

  const { data, error } = await supabase
    .from(tableName)
    .select('*')
    .order('created_at', { ascending: false }); // Optional: newest first

  if (error) {
    throw new Error(`Error fetching ${tableName}: ${error.message}`);
  }

  return data;
};